import * as angular from "angular";
import {IComponentOptions, ILogService, IScope, IWindowService} from "angular";
import {StateService} from "@uirouter/angularjs";
import {IModalInstanceService, IModalService} from "angular-ui-bootstrap";
import {LoadingService} from "../../../loading/loading.service";
import {ApplicationService} from "../../application.service";
import {Application} from "../../../model/Application";
import {User} from "../../../model/User";
import {IReferenceDataItem, ReferenceData} from "../../../reference-data/reference-data.service";

class ApplicationApproveModalController {

    public modalInstance: IModalInstanceService;
    public resolve: any;
    public close: any;
    public dismiss: any;
    public application: Application;
    public currentUser: User;
    public outcomeComment: string;
    public personUsername: string;
    public adjustedCourseDuration: string;
    public govCreditBasisData: IReferenceDataItem[];
    public govCreditBasis: string;

    /* @ngInject */
    constructor(private $log: ILogService,
                private $state: StateService,
                private $uibModal: IModalService,
                private toaster: any,
                private loadingService: LoadingService,
                private applicationService: ApplicationService,
                private referenceData: ReferenceData) {
        this.govCreditBasisData = this.referenceData.getAll("GovernmentCreditBasis");
    }

    public $onInit() {
        this.application = this.resolve.application;
        this.currentUser = this.resolve.currentUser;
        this.personUsername = this.currentUser.username;
        this.outcomeComment = this.application.outcomeComment;
        this.adjustedCourseDuration = this.application.adjustedCourseDuration;
        this.govCreditBasis = this.application.govCreditBasis;
    }

    public submit() {
        this.$log.info("submit()");
        this.loadingService.show();

        if (this.outcomeComment !== this.application.outcomeComment) {
            this.application.outcomeComment = this.outcomeComment;
        }

        if (this.adjustedCourseDuration !== this.application.adjustedCourseDuration) {
            this.application.adjustedCourseDuration = this.adjustedCourseDuration;
        }

        if (this.govCreditBasis !== this.application.govCreditBasis) {
            this.application.govCreditBasis = this.govCreditBasis;
        }

        this.applicationService.approveStudentCreditApplicationByFacultyAdmin(this.application, this.personUsername)
            .then((grantedApplication) => {
                this.dismiss({$value: "cancel"});

                // Open a popup message
                const modalInstance = this.$uibModal.open({
                    template: `<div class="modal-body" style="
                                    text-align: center;
                                    font-size: 20px;
                                    color: #E30000;
                                    border-radius: 18px;
                                    font-weight: bold;
                                    padding: 20px;">
                                    <i class="fa fa-spin fa-circle-o-notch"></i>&nbsp;&nbsp;
                                    Sending to Callista, please wait and check the application status ...</div>`,
                    backdrop: 'static', // Prevents clicking outside to close the modal
                    keyboard: false,    // Prevents closing with the Escape key
                    size: 'lg'
                });


                // Wait for a few seconds before closing the popup
                setTimeout(() => {
                    modalInstance.dismiss('close');
                    this.close({$value: grantedApplication});
                    this.$state.go("staff.assess", {}, {reload: true});
                }, 4000); // Change 4000 to the desired delay in milliseconds
            })
            .catch((reason) => {
                this.$log.debug("Failed to update Callista", reason);
                if (reason.data && reason.data.message) {
                    if (reason.data.message.indexOf("A invalid response of status") !== -1) {
                        //Detailed message is available
                        const regexString = "A invalid response of status \\d{3} was returned:";
                        const regex = new RegExp(regexString, "g");
                        const result = reason.data.message.replace(regex, "");
                        const errorMessageObject = angular.fromJson(result);
                        this.$log.debug("Callista message object: %o", errorMessageObject);
                        this.toaster.pop({type: "failure", title: "Failed to update Advanced Standing record: " + errorMessageObject.errorDetails.errors[0]});
                    } else {
                        //Generic message with some failure details
                        this.toaster.pop({type: "failure", title: "Failed to update Advanced Standing record: " + reason.data.message});
                    }
                } else {
                    //Generic error message
                    this.toaster.pop({type: "failure", title: "Failed to update Advanced Standing record"});
                }
            })
            .finally(() => {
                this.loadingService.hide();
            });
    }

    public cancel() {
        this.dismiss({$value: "cancel"});
    }
}

export const ApplicationApproveModalComponent: IComponentOptions = {
    bindings: {
        modalInstance: "<",
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    controller: ApplicationApproveModalController,
    template: require("./application-approve-modal.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/application/modals/approve-modal/application-approve-modal.component.ts